import React, { useEffect } from "react";
import useAlbum from "../../../../Logic/useAlbum";
import Style from "./CreateSection.module.scss";
const CreateSection = ({
  handleClose,
  title,
  label,
  leftBtn,
  rightBtn,
  handleClick,
  placeholder,
}) => {
  const {
    handleChangeAlbumName,
    handleSubmitAlbumName,
    handleCloseAddNewAlbum,
    albumName,
    handleCreateAlbumWithName,
    isAlbumCreating,
  } = useAlbum();

  useEffect(() => {
    setTimeout(() => {
      document.querySelectorAll(".modal input")[0].focus();
    }, 500);
  }, []);

  return (
    <div>
      <div className={Style.create_slideshow_modal_content}>
        <h3 className={Style.create_slideshow_modal_title}>{title}</h3>
        <div className="form-group">
          <label className={Style.slideshow_name_label}>{label}</label>
          <input
            className={`${Style.slideshow_name_input} form-control`}
            placeholder={placeholder}
            value={albumName}
            onChange={(e) => handleChangeAlbumName(e)}
          />
        </div>
        <div className={Style.create_slideshow_modal_actions}>
          <button
            disabled={albumName?.length > 0 ? false : true}
            onClick={(e) => handleCreateAlbumWithName(e)}
            className="btn btn-sm btn-secondary"
          >
            {leftBtn}
          </button>
          <button
            className="btn btn-sm btn-border-grey"
            onClick={() => handleCloseAddNewAlbum()}
          >
            {rightBtn}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateSection;
